import { render, staticRenderFns } from "./BsGridRowhead.vue?vue&type=template&id=5daccf90&scoped=true&"
import script from "./BsGridRowhead.vue?vue&type=script&lang=js&"
export * from "./BsGridRowhead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daccf90",
  null
  
)

export default component.exports